import { Box, Typography } from "@mui/material"
import { useState } from "react"
import { Searchbar } from "../../components/Searchbar/Searchbar"

export const PrivateMessages = () => {

    const [searchText, setSearchText] = useState('')

    const handleSearchTextChange = (text: string) => {
        setSearchText(text)
    }

    return (
        <Box>
            <Typography variant='h3' sx={{ fontSize: '1.5rem', fontWeight: 400, textAlign: 'center', mt: 3 }}>
                Private Messages
            </Typography>
            <Searchbar sx={{ mt: 3 }} text={searchText} setText={handleSearchTextChange} debounce={500} />
        </Box>
    )
}